import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ContractPDF from "./ContractPDF";
import {
  getContractInfoById,
  getSocieteByUser,
  isExistContract,
} from "../../../../services/RHService/ContractService";
import { useLocation } from "react-router-dom";
import NotFound from "../../ErrorPages/NotFound";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const ContractDetail = () => {
  const [contractDetail, setContractDetail] = useState(null);
  const [societeDetail, setSocieteDetail] = useState(null);

  const [existContract, setExistContract] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isExistCheckComplete, setIsExistCheckComplete] = useState(false);

  const location = useLocation();
  const id = new URLSearchParams(location.search).get("idContract");

  const fetchDataIsExistContract = async () => {
    try {
      const response = await isExistContract(id);
      setExistContract(response.data?.exists);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsExistCheckComplete(true);
    }
  };

  const fetchData = async () => {
    try {
      const response = await getContractInfoById(id);
      setContractDetail(response.data);
      console.log(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
    const fetchDataSociete = async () => {
    try {
      const response = await getSocieteByUser(getCurrentUserId());
      setSocieteDetail(response.data.success);
      console.log(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
//  useEffect(() => {
//     fetchDataSociete();
//   }, []);
  
  useEffect(() => {
        fetchDataIsExistContract();
             fetchDataSociete();
              
  }, [id])

  useEffect(() => {
    if (isExistCheckComplete && existContract) {
      fetchData();
    }
  }, [isExistCheckComplete, existContract]);

  if (!existContract && isExistCheckComplete) {
    return (
      <div>
        <NotFound />
      </div>
    );
  }

  if (isLoading || !isExistCheckComplete) {
    return <div className="loader center"></div>;
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">
                Contrat/
                {contractDetail
                  ? contractDetail.firstname + " " + contractDetail.lastname
                  : ""}
              </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i className="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item ">
                  <Link to="/contractList">Liste des contrats</Link>
                </li>
                <li className="breadcrumb-item active">Détail de contrat</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="container-md">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-dark">
              <div className="card-header ">
                <h6 className="text-center">
                  {" "}
                  {contractDetail ? contractDetail.contractType : ""}
                </h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 col-lg-12 col-sm-12">
                    <strong> Entre les soussignés :</strong> <br></br>
                    La Société {societeDetail? societeDetail?.title:""}, société de services sise à {societeDetail? societeDetail?.adresse:""} registre de commerce N°{societeDetail? societeDetail?.matricule:""}{" "}
                    représentée par son gérant Mr/Mme {societeDetail? societeDetail?.representant:""}.
                    <br></br>
                    <strong> D’une part</strong>
                    <br></br>
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}{" "}
                    Tunisien(ne), née en Tunisie le{" "}
                    {contractDetail ? contractDetail.datenais : ""} , titulaire
                    de la carte d’identité nationale n°{" "}
                    {contractDetail ? contractDetail.cin : ""} et demeurant à{" "}
                    {contractDetail ? contractDetail.adr : ""}{" "}
                    {contractDetail ? contractDetail.country : ""}{" "}
                    {contractDetail ? contractDetail.postalCode : ""}.<br></br>
                    <strong> D’autre part</strong>
                    <br></br>
                    <br></br>
                    <h6>
                      {" "}
                      <strong>
                        {" "}
                        Il a été arrêté et convenu ce qui suit :
                      </strong>{" "}
                    </h6>
                    <br></br>
                    <strong> ARTICLE 1 : Engagement</strong>
                    <br></br>
                    La Société {societeDetail? societeDetail?.title:""}, engage aux termes du présent contrat de
                    travail{" "}
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}
                    , qui l’accepte, de travailler en tant que{" "}
                    {contractDetail ? contractDetail.nomPost : ""}. Le présent
                    contrat sera régi par les dispositions légales,
                    réglementaires et conventionnelles applicables au secteur
                    d’activité.
                    <br></br>
                    <strong> ARTICLE 2 : Horaires de travail</strong>
                    <br></br>
                    Le présent contrat est conclu et accepté pour un horaire de
                    travail de{" "}
                    {contractDetail ? contractDetail.nb_hrs_mois : ""} heures
                    par mois.
                    <br></br>
                    <strong> ARTICLE 3 : Durée du contrat</strong> <br></br>
                    Le présent contrat est conclu et accepté pour une durée de{" "}
                    {contractDetail ? contractDetail.duree : ""} commençant le{" "}
                    {contractDetail ? contractDetail.date_deb : ""} et finissant
                    le {contractDetail ? contractDetail.date_fin : ""}.<br></br>
                    <strong> ARTICLE 4 : Rémunération</strong>
                    <br></br>
                    En contrepartie de l’accomplissement de ses fonctions,{" "}
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}{" "}
                    percevra un salaire fixe mensuel net de (
                    {contractDetail ? contractDetail.montant_brut : ""} DT).
                    <br></br>
                    <strong> ARTICLE 5 : Obligations professionnelles</strong>
                    <br></br>
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}{" "}
                    s’engage formellement :<br></br>- A consacrer tout son temps
                    au service où il est affecté, suivant l’horaire établi par
                    la direction de l’établissement.<br></br>- A se conformer
                    aux instructions qui lui seront données par les personnes
                    sous les ordres desquelles il est placé.<br></br>- A
                    observer le secret professionnel et à ne faire, sans
                    l’autorisation écrite de ses chefs, aucune communication
                    écrite ou verbale à des tiers sur les questions se
                    rattachant aux travaux pour lesquels il est engagé.<br></br>
                    - A prendre soin du matériel qui lui sera confié.<br></br>-
                    Et d’une façon générale à respecter les lois et règlements
                    généraux ou particuliers en vigueur.<br></br>
                    <br></br>
                    <strong> ARTICLE 6 : Dispositions diverses</strong>{" "}
                    <br></br>
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}{" "}
                    déclare formellement n’être lié à aucune autre entreprise,
                    être libre de tout engagement. En outre,{" "}
                    {contractDetail
                      ? contractDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {contractDetail
                      ? contractDetail.firstname + " " + contractDetail.lastname
                      : ""}{" "}
                    s’engage à faire connaître, sans délai, tout changement qui
                    interviendrait dans sa situation, concernant son adresse,
                    situation familiale…
                    <br></br>
                    <br></br>
                    Fait à Tunis le{" "}
                    {contractDetail ? contractDetail.date_deb : " "}
                    <br></br>
                    <br></br>
                    <strong>L’employeur</strong>
                    <br></br>
                    <br></br>
                    <br></br>
                    <strong> L’employé</strong>
                    <br></br>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="submit"
                  className="btn btn-danger col-md-3 float-right"
                  style={{ width: "auto", color: "white" }}
                >
                  <PDFDownloadLink
                    document={
                      <ContractPDF id={id} contractDetail={contractDetail} />
                    }
                    fileName="Contrat.pdf"
                    style={{ color: "white" }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? "Loading document..." : "Télecharger"
                    }
                  </PDFDownloadLink>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractDetail;
